import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { replaceColorTag } from "../../../functions/stringFunctions";
import { CONSUME_TYPE, ITEM_REGION, LOCALES } from "../../../constants";
import { loadData } from "../../../functions/dataLoader";
import FILTERS from "../../../config/filter_config.json";
import SORT_LIST from "../../../config/sort_config.json";

const rarity_score = {
    IG_LEGENDARY: 0,
    IG_UNIQUE: 1,
    IG_RARE: 2,
};

const type_score = {
    NT_CHARM: 0,
    NT_COOK: 1,
    NT_TRAINING_EXP_ITEM: 2,
    NT_VALUABLES: 3,
};

const normalizeItems = (originData) => {
    const lang = localStorage.getItem("language") || LOCALES.KO;
    const ids = [];
    const entities = {};

    originData.forEach((data) => {
        if (data.name[LOCALES.KO] === "리더") return;
        ids.push(data.id);

        const parts = [data.name[LOCALES.KO], data.description[LOCALES.KO]];
        const parts_ENG = [data.name[LOCALES.EN], data.description[LOCALES.EN]];

        if (data.charm_info) {
            data.charm_info.se_list.forEach((se) => {
                parts.push(replaceColorTag(se[LOCALES.KO]));
                parts_ENG.push(replaceColorTag(se[LOCALES.EN]));
            });
        }

        if (data.stats) {
            parts.push(
                ...data.stats.map((stat) => `${CONSUME_TYPE[stat.type][LOCALES.KO]} ${stat.value < 0 ? stat.value : `+${stat.value}`}`),
            );
            parts_ENG.push(
                ...data.stats.map((stat) => `${CONSUME_TYPE[stat.type][LOCALES.EN]} ${stat.value < 0 ? stat.value : `+${stat.value}`}`),
            );
        }

        if (data.events) {
            parts.push(...data.events.map((e) => e[LOCALES.KO]));
            parts_ENG.push(...data.events.map((e) => e[LOCALES.EN]));
        }
        if (data.regions) {
            parts.push(...data.regions.map((e) => ITEM_REGION[e][LOCALES.KO]));
            parts_ENG.push(...data.regions.map((e) => ITEM_REGION[e][LOCALES.EN]));
        }

        entities[data.id] = {
            ...data,
            searchText: parts.join(" "),
            searchText_ENG: parts_ENG.join(" "),
        };
    });

    ids.sort((a, b) => {
        const typeDiff = type_score[entities[a].type] - type_score[entities[b].type];
        if (typeDiff !== 0) return typeDiff;
        const rarityDiff = rarity_score[entities[a].rarity] - rarity_score[entities[b].rarity];
        if (rarityDiff !== 0) return rarityDiff;
        return entities[a].name[lang].localeCompare(entities[b].name[lang], lang);
    });

    return { ids, entities };
};

export const initItems = createAsyncThunk("items/init", async () => {
    const [originData] = await Promise.all([loadData("journey_items.json")]);
    const normalized = normalizeItems(originData);
    return normalized;
});

const itemSlice = createSlice({
    name: "items",
    initialState: {
        ids: [],
        entities: {},
        filter: {
            type: FILTERS.ITEM_TYPE[0],
            sort: SORT_LIST.ITEM_SORT[0],
        },
        status: "idle",
    },
    reducers: {
        setSortFilter: (state, action) => {
            state.filter.sort = action.payload.obj;
        },
        setTypeFilter: (state, action) => {
            state.filter.type = action.payload.obj;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initItems.fulfilled, (state, action) => {
            const normalized = action.payload;
            state.ids = normalized.ids;
            state.entities = normalized.entities;
            // state.filter = {
            //     type: FILTERS.ITEM_TYPE[0],
            //     sort: SORT_LIST.ITEM_SORT[0],
            // };
            state.status = "done";
        });
    },
});

export const { setSortFilter, setTypeFilter } = itemSlice.actions;
export default itemSlice.reducer;
